module.exports = __webpack_public_path__ + "assets/a83dc8dead7ebbbe98ee4c06eab0222b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/jlondon/Desktop/Work-Resize/roc2/plugins/slot/public-src/common/sounds/bell.mp3
 ** module id = 173
 ** module chunks = 0
 **/